module.exports = __webpack_public_path__ + "static/media/manzo_04_full.6fcd7495.jpg";